export const banners = [
  {
    id: "1",
    image: {
      default: "/images/home/banner-1-mobile.jpg",
      desktop: "/images/home/banner-1-desktop.jpg",
    },
    title: (
      <>
        簡單一杯好咖啡
        <br />
        為生活注入詩意與平靜
      </>
    ),
    description: (
      <>
        不論是工作忙碌的日子，還是悠閒在家的日子
        <br />
        簡單單替自己準備一杯咖啡，享受迷人咖啡香帶來的片刻寧靜
      </>
    ),
    link: {
      href: "/shop",
      text: "來去逛逛",
    },
  },
  {
    id: "2",
    image: {
      default: "/images/home/banner-2-mobile.jpg",
      desktop: "/images/home/banner-2-desktop.jpg",
    },
    title: (
      <>
        新鮮烘焙
        <br /> 讓你每一口都香醇
      </>
    ),
    description: (
      <>
        咖啡的香氣與風味隨時間流逝，
        <br />
        唯有新鮮烘焙，為您留住完整的香醇風味
      </>
    ),
    link: {
      href: "/shop",
      text: "來去逛逛",
    },
  },
];

export const features = [
  {
    img: "/images/home/features-fresh-roasted.png",
    title: "自家新鮮烘焙",
    description: "Fresh Roasted",
  },
  {
    img: "/images/home/features-premium-beans.png",
    title: "高品質咖啡豆",
    description: "Premium Beans",
  },
  {
    img: "/images/home/features-handpicked-flavors.png",
    title: "嚴選風味",
    description: "Handpicked Flavors",
  },
  {
    img: "/images/home/features-brew-with-easy.png",
    title: "方便沖泡",
    description: "Brew with Ease",
  },
];
